<!-- Parcel Detail Popup -->
<div class="popup-overlay" [class.show]="visible" (click)="close()">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h4 class="popup-title">
        <i class="fas fa-box me-2"></i>
        Dettagli Collo
      </h4>
      <button type="button" class="btn-close" (click)="close()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Tabs Navigation -->
    <div class="popup-tabs">
      <button type="button"
              class="tab-btn"
              [class.active]="activeTab === 'details'"
              (click)="setActiveTab('details')">
        <i class="fas fa-info-circle me-2"></i>
        Dettagli
      </button>
      <button type="button"
              class="tab-btn"
              [class.active]="activeTab === 'events'"
              (click)="setActiveTab('events')">
        <i class="fas fa-history me-2"></i>
        Eventi
      </button>
      <button type="button"
              class="tab-btn"
              [class.active]="activeTab === 'images'"
              (click)="setActiveTab('images')">
        <i class="fas fa-images me-2"></i>
        Immagini
      </button>
      <button type="button"
              class="tab-btn"
              [class.active]="activeTab === 'routing'"
              (click)="setActiveTab('routing')">
        <i class="fas fa-route me-2"></i>
        Instradamento
      </button>
      <button type="button" 
              class="tab-btn" 
              [class.active]="activeTab === 'barcode'"
              (click)="setActiveTab('barcode')">
        <i class="fas fa-barcode me-2"></i>
        Barcode/QR
      </button>
      <button type="button"
              class="tab-btn"
              [class.active]="activeTab === 'map'"
              (click)="setActiveTab('map')">
        <i class="fas fa-map-marker-alt me-2"></i>
        Mappa
      </button>
      <button type="button" 
              class="tab-btn" 
              [class.active]="activeTab === 'functions'"
              (click)="setActiveTab('functions')">
        <i class="fas fa-cogs me-2"></i>
        Funzionalità
      </button>
    </div>

    <div class="popup-body">
      <!-- Tab: Dettagli -->
      <div class="tab-content" *ngIf="activeTab === 'details'">
        <div class="parcel-details">

          <!-- Header riepilogo: codice collo + status + tipo -->
          <div class="details-summary" *ngIf="parcel">
            <div class="details-summary-item">
              <i class="fas fa-box"></i>
              <span>Codice: <strong>{{ parcel?.parcelCode || displayCode || '-' }}</strong></span>
            </div>
            <div class="details-summary-item" *ngIf="parcel?.parcelType">
              <span class="details-pill"
                    [ngClass]="{
                      'type-urgent': parcel?.parcelType === 'U',
                      'type-stock': parcel?.parcelType === 'S'
                    }">
                <i class="fas me-1"
                   [ngClass]="{
                     'fa-exclamation-circle': parcel?.parcelType === 'U',
                     'fa-box': parcel?.parcelType === 'S'
                   }"></i>
                {{ parcel?.parcelType === 'U' ? 'Urgent' : parcel?.parcelType === 'S' ? 'Stock' : parcel?.parcelType }}
              </span>
            </div>
            <div class="details-summary-item" *ngIf="parcel?.parcelDeliveryStatus">
              <span class="details-status-badge"
                    [ngClass]="{
                      'status-executed': isDelivered(),
                      'status-in-progress': !isDelivered() && !isDelayed(),
                      'status-failed': !isDelivered() && isDelayed()
                    }">
                <i class="fas fa-circle status-dot"></i>
                {{ parcel?.parcelDeliveryStatus }}
              </span>
            </div>
          </div>

          <!-- Sezione Stato e Consegna -->
          <div class="details-card"
               *ngIf="parcel"
               [class.is-delivered]="parcel?.parcelDeliveryDate">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-truck"></i>
              </div>
              <h5 class="details-card-title">Stato e Consegna</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Stato Consegna</span>
                  <div class="details-value">
                    <span class="details-status-badge"
                          *ngIf="parcel?.parcelDeliveryStatus; else noStatus"
                          [ngClass]="{
                            'status-executed': isDelivered(),
                            'status-in-progress': !isDelivered() && !isDelayed(),
                            'status-failed': !isDelivered() && isDelayed()
                          }">
                      <i class="fas fa-circle status-dot"></i>
                      {{ parcel?.parcelDeliveryStatus }}
                    </span>
                    <ng-template #noStatus><span class="text-muted">-</span></ng-template>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Metodo Consegna</span>
                  <div class="details-value">{{ parcel?.parcelDeliveryMethod || '-' }}</div>
                </div>
                <div class="details-item">
                  <span class="details-label">Tipo Consegna</span>
                  <div class="details-value">{{ parcel?.parcelDeliveryType || '-' }}</div>
                </div>
                <div class="details-item">
                  <span class="details-label">Data Consegna</span>
                  <div class="details-value">
                    <ng-container *ngIf="parcel?.parcelDeliveryDate; else noDeliveryDate">
                      <i class="fas fa-check-circle text-success me-1"></i>
                      {{ parcel?.parcelDeliveryDate | date:'dd/MM/yyyy HH:mm' }}
                    </ng-container>
                    <ng-template #noDeliveryDate>
                      <span class="details-status-badge"
                            [ngClass]="isDelayed() ? 'status-failed' : 'status-in-progress'">
                        <i class="fas fa-circle status-dot"></i>
                        {{ isDelayed() ? 'In Ritardo' : 'In Consegna' }}
                      </span>
                    </ng-template>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Data Prevista</span>
                  <div class="details-value">
                    {{ parcel?.parcelEstimatedDeliveryDate ? (parcel?.parcelEstimatedDeliveryDate | date:'dd/MM/yyyy HH:mm') : '-' }}
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Posizione</span>
                  <div class="details-value">{{ parcel?.parcelLocation || '-' }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Identificazione Collo -->
          <div class="details-card">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-box"></i>
              </div>
              <h5 class="details-card-title">Identificazione Collo</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Codice Collo</span>
                  <div class="details-value details-value--code">
                    <span>{{ parcel?.parcelCode || displayCode || '-' }}</span>
                    <i *ngIf="parcel?.parcelCode || displayCode"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(parcel?.parcelCode || displayCode)"
                       title="Copia codice collo"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Barcode</span>
                  <div class="details-value details-value--code">
                    <span>{{ parcel?.parcelBarcode || '-' }}</span>
                    <i *ngIf="parcel?.parcelBarcode"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(parcel?.parcelBarcode)"
                       title="Copia barcode"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Tracking Number</span>
                  <div class="details-value details-value--code">
                    <span>{{ parcel?.parcelTrackingNumber || '-' }}</span>
                    <i *ngIf="parcel?.parcelTrackingNumber"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(parcel?.parcelTrackingNumber)"
                       title="Copia tracking"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Codice Bolla</span>
                  <div class="details-value details-value--code">
                    <span>{{ parcel?.parcelWaybillCode || '-' }}</span>
                    <i *ngIf="parcel?.parcelWaybillCode"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(parcel?.parcelWaybillCode)"
                       title="Copia codice bolla"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Tipo Collo</span>
                  <div class="details-value">
                    <span class="details-pill"
                          *ngIf="parcel?.parcelType; else noType"
                          [ngClass]="{
                            'type-urgent': parcel?.parcelType === 'U',
                            'type-stock': parcel?.parcelType === 'S'
                          }">
                      <i class="fas me-1"
                         [ngClass]="{
                           'fa-exclamation-circle': parcel?.parcelType === 'U',
                           'fa-box': parcel?.parcelType === 'S'
                         }"></i>
                      {{ parcel?.parcelType === 'U' ? 'Urgent' : parcel?.parcelType === 'S' ? 'Stock' : parcel?.parcelType }}
                    </span>
                    <ng-template #noType><span class="text-muted">-</span></ng-template>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Descrizione</span>
                  <div class="details-value">{{ parcel?.parcelDescription || '-' }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Dimensioni e Peso -->
          <div class="details-card" *ngIf="parcel">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-ruler-combined"></i>
              </div>
              <h5 class="details-card-title">Dimensioni e Peso</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid details-grid--metrics">
                <div class="details-metric">
                  <i class="fas fa-weight-hanging metric-icon"></i>
                  <div class="metric-text">
                    <span class="details-label">Peso</span>
                    <div class="details-value">{{ parcel?.parcelWeight ? (parcel?.parcelWeight + ' kg') : '-' }}</div>
                  </div>
                </div>
                <div class="details-metric">
                  <i class="fas fa-cube metric-icon"></i>
                  <div class="metric-text">
                    <span class="details-label">Volume</span>
                    <div class="details-value">{{ parcel?.parcelVolume ? (parcel?.parcelVolume + ' m³') : '-' }}</div>
                  </div>
                </div>
                <div class="details-metric">
                  <i class="fas fa-ruler-horizontal metric-icon"></i>
                  <div class="metric-text">
                    <span class="details-label">Lunghezza</span>
                    <div class="details-value">{{ parcel?.parcelLength ? (parcel?.parcelLength + ' cm') : '-' }}</div>
                  </div>
                </div>
                <div class="details-metric">
                  <i class="fas fa-ruler-vertical metric-icon"></i>
                  <div class="metric-text">
                    <span class="details-label">Larghezza</span>
                    <div class="details-value">{{ parcel?.parcelWidth ? (parcel?.parcelWidth + ' cm') : '-' }}</div>
                  </div>
                </div>
                <div class="details-metric">
                  <i class="fas fa-arrows-alt-v metric-icon"></i>
                  <div class="metric-text">
                    <span class="details-label">Altezza</span>
                    <div class="details-value">{{ parcel?.parcelHeight ? (parcel?.parcelHeight + ' cm') : '-' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Dealer -->
          <div class="details-card details-card--dealer"
               [class.is-delivered]="parcel?.parcelDeliveryDate">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-store"></i>
              </div>
              <h5 class="details-card-title">
                Destinatario (Dealer)
                <span class="details-card-tag"
                      *ngIf="parcel?.parcelDeliveryDate">
                  <i class="fas fa-check me-1"></i>Consegnato
                </span>
              </h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Codice Dealer</span>
                  <div class="details-value details-value--code">
                    <span>{{ dealer?.dealerCode || '-' }}</span>
                    <i *ngIf="dealer?.dealerCode"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(dealer?.dealerCode)"
                       title="Copia codice dealer"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Nome</span>
                  <div class="details-value">{{ dealer?.dealerName || '-' }}</div>
                </div>
                <div class="details-item">
                  <span class="details-label">Ragione Sociale</span>
                  <div class="details-value">{{ dealer?.dealerLegalName || '-' }}</div>
                </div>
                <div class="details-item details-item--wide">
                  <span class="details-label">Indirizzo</span>
                  <div class="details-value">
                    <ng-container *ngIf="dealer?.dealerOperatingAddressStreet || dealer?.dealerOperatingAddressCity; else noAddress">
                      <div>
                        <i class="fas fa-road me-1 text-muted"></i>
                        {{ dealer?.dealerOperatingAddressStreet }} {{ dealer?.dealerOperatingAddressNumber }}
                      </div>
                      <div>
                        <i class="fas fa-city me-1 text-muted"></i>
                        {{ dealer?.dealerOperatingAddressZip }} {{ dealer?.dealerOperatingAddressCity }}
                        <ng-container *ngIf="dealer?.dealerOperatingAddressProvince">
                          ({{ dealer?.dealerOperatingAddressProvince }})
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-template #noAddress><span class="text-muted">-</span></ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Date -->
          <div class="details-card" *ngIf="parcel">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-calendar"></i>
              </div>
              <h5 class="details-card-title">Date</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Data Collo</span>
                  <div class="details-value">
                    <i class="fas fa-calendar-day me-1 text-muted"></i>
                    {{ parcel?.parcelDate ? (parcel?.parcelDate | date:'dd/MM/yyyy') : '-' }}
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Creato il</span>
                  <div class="details-value">
                    <i class="fas fa-calendar-plus me-1 text-muted"></i>
                    {{ parcel?.parcelCreatedAt ? (parcel?.parcelCreatedAt | date:'dd/MM/yyyy HH:mm') : '-' }}
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Ultimo Aggiornamento</span>
                  <div class="details-value">
                    <i class="fas fa-history me-1 text-muted"></i>
                    {{ parcel?.parcelLastUpdateAt ? (parcel?.parcelLastUpdateAt | date:'dd/MM/yyyy HH:mm') : '-' }}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Tab: Eventi -->
      <div class="tab-content" *ngIf="activeTab === 'events'">
        <div class="events-section">

          <!-- Collo segnalato come danneggiato, ma senza evento di danno -->
          <div class="details-alert details-alert--danger mb-3" *ngIf="isDamagedWithoutEvent()">
            <div class="details-alert-icon">
              <i class="fas fa-exclamation-triangle"></i>
            </div>
            <div class="details-alert-body">
              <div class="details-alert-title">Collo danneggiato: evento di danno non trovato</div>
              <div class="details-alert-text">
                Il collo è segnalato come danneggiato, ma tra gli eventi non risulta nessun evento di danno.
              </div>
            </div>
          </div>

          <!-- Loading state -->
          <div class="events-state-box" *ngIf="isLoadingEvents">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Caricamento...</span>
            </div>
            <p class="mt-3 text-muted mb-0">Caricamento eventi...</p>
          </div>

          <!-- Empty state -->
          <div class="events-state-box" *ngIf="!isLoadingEvents && parcelEvents.length === 0">
            <i class="fas fa-history fa-3x text-muted mb-3"></i>
            <p class="text-muted mb-0">Nessun evento disponibile per questo collo.</p>
          </div>

          <!-- Header riepilogo -->
          <div class="events-summary" *ngIf="!isLoadingEvents && parcelEvents.length > 0">
            <div class="events-summary-item">
              <i class="fas fa-history"></i>
              <span><strong>{{ parcelEvents.length }}</strong> {{ parcelEvents.length === 1 ? 'evento' : 'eventi' }}</span>
            </div>
            <div class="events-summary-item" *ngIf="lastEventDate">
              <i class="fas fa-clock"></i>
              <span>Ultimo evento: <strong>{{ lastEventDate | date:'dd/MM/yyyy HH:mm' }}</strong></span>
            </div>
          </div>

          <!-- Timeline eventi (il più recente in cima) -->
          <div class="events-timeline" *ngIf="!isLoadingEvents && parcelEvents.length > 0">
            <div class="event-item"
                 *ngFor="let event of parcelEvents; let i = index; let isLast = last"
                 [class.is-last]="isLast">

              <!-- Marker laterale: dot + connettore -->
              <div class="event-marker">
                <div class="event-marker-dot" [ngClass]="getEventVariantClass(event)">
                  <i class="fas" [ngClass]="getEventIcon(event)"></i>
                </div>
                <div class="event-connector" *ngIf="!isLast"></div>
              </div>

              <!-- Corpo evento -->
              <div class="event-body" [class.event-body--damage]="isDamageEvent(event)">
                <div class="event-header">
                  <span class="event-title">
                    {{ getEventLabel(event) }}
                    <span class="event-raw-name"
                          *ngIf="event.parcelEventComplementaryName && getEventLabel(event) !== event.parcelEventComplementaryName">
                      {{ event.parcelEventComplementaryName | lowercase }}
                    </span>
                  </span>
                  <span class="event-status-text" [ngClass]="getEventStatusClass(event)"
                        *ngIf="event.parcelEventComplementaryStatus">
                    {{ event.parcelEventComplementaryStatus }}
                  </span>
                </div>
                <div class="event-meta">
                  <span class="event-meta-item" *ngIf="event.parcelEventComplementaryCreatedAt">
                    <i class="far fa-clock"></i>
                    {{ event.parcelEventComplementaryCreatedAt | date:'dd/MM/yyyy HH:mm' }}
                  </span>
                  <span class="event-meta-item event-meta-item--warehouse"
                        *ngIf="event.parcelEventComplementaryWarehouseFrom || event.parcelEventComplementaryWarehouseTo">
                    <i class="fas fa-warehouse"></i>
                    {{ getWarehouseName(event.parcelEventComplementaryWarehouseFrom || event.parcelEventComplementaryWarehouseTo) }}
                  </span>
                  <span class="event-meta-item" *ngIf="event.loadingListCode">
                    <i class="fas fa-list-check"></i> {{ event.loadingListCode }}
                  </span>
                  <span class="event-meta-item" *ngIf="event.parcelEventComplementaryCreatedBy">
                    <i class="fas fa-user"></i> {{ event.parcelEventComplementaryCreatedBy }}
                  </span>
                </div>

                <!-- Evento danno: dettagli chiusi di default, si aprono su richiesta -->
                <ng-container *ngIf="isDamageEvent(event); else standardEventDetails">
                  <button type="button" class="damage-details-toggle"
                          *ngIf="hasDamageDetails(event)"
                          [attr.aria-expanded]="isDamageDetailsExpanded(i)"
                          (click)="toggleDamageDetails(i)">
                    <i class="fas" [ngClass]="isDamageDetailsExpanded(i) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    {{ isDamageDetailsExpanded(i) ? 'Nascondi dettagli' : 'Mostra dettagli della Notifica' }}
                  </button>

                  <div class="damage-details" *ngIf="isDamageDetailsExpanded(i) && hasDamageDetails(event)">
                    <ng-container *ngIf="getDamageDetailRows(event) as rows; else damageRawNote">
                      <div class="damage-details-row" *ngFor="let row of rows">
                        <span class="damage-details-label">{{ row.label }}</span>
                        <span class="damage-details-value">{{ row.value }}</span>
                      </div>
                    </ng-container>
                    <ng-template #damageRawNote>
                      <div class="damage-details-text" *ngIf="event.parcelEventComplementaryValueClob">
                        {{ event.parcelEventComplementaryValueClob }}
                      </div>
                    </ng-template>
                    <div class="damage-details-row" *ngIf="getEventValue(event) as value">
                      <span class="damage-details-label">Valore</span>
                      <span class="damage-details-value">{{ value }}</span>
                    </div>
                  </div>
                </ng-container>

                <ng-template #standardEventDetails>
                  <div class="event-note" *ngIf="event.parcelEventComplementaryValueClob">
                    <i class="fas fa-sticky-note me-1"></i>{{ getEventNote(event, i) }}
                    <button type="button" class="event-note-toggle"
                            *ngIf="isEventNoteTruncatable(event)"
                            (click)="toggleEventNote(i)">
                      {{ isEventNoteExpanded(i) ? 'Mostra meno' : 'Mostra di più' }}
                    </button>
                  </div>
                  <div class="event-value" *ngIf="getEventValue(event)">
                    <i class="fas fa-info-circle me-1"></i>{{ getEventValue(event) }}
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab: Immagini -->
      <div class="tab-content" *ngIf="activeTab === 'images'">
        <div class="images-section">

          <!-- Loading state -->
          <div class="events-state-box" *ngIf="isLoadingImages">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Caricamento...</span>
            </div>
            <p class="mt-3 text-muted mb-0">Caricamento immagini...</p>
          </div>

          <!-- Empty state -->
          <div class="events-state-box" *ngIf="!isLoadingImages && images.length === 0">
            <i class="fas fa-images fa-3x text-muted mb-3"></i>
            <p class="text-muted mb-0">Nessuna immagine disponibile per questo collo.</p>
          </div>

          <!-- Toolbar: riepilogo + toggle vista -->
          <div class="routing-toolbar" *ngIf="!isLoadingImages && images.length > 0">
            <div class="routing-summary">
              <div class="routing-summary-item">
                <i class="fas fa-images"></i>
                <span><strong>{{ images.length }}</strong> {{ images.length === 1 ? 'immagine' : 'immagini' }}</span>
              </div>
            </div>
            <div class="routing-view-toggle" role="group" aria-label="Modalità di visualizzazione">
              <button type="button"
                      class="view-toggle-btn"
                      [class.active]="imagesViewMode === 'grid'"
                      (click)="imagesViewMode = 'grid'"
                      title="Vista compatta a griglia">
                <i class="fas fa-stream"></i>
                <span>Compatta</span>
              </button>
              <button type="button"
                      class="view-toggle-btn"
                      [class.active]="imagesViewMode === 'list'"
                      (click)="imagesViewMode = 'list'"
                      title="Vista lista, una sotto l'altra">
                <i class="fas fa-th-large"></i>
                <span>Lista</span>
              </button>
            </div>
          </div>

          <!-- Vista compatta (griglia) -->
          <div class="images-grid" *ngIf="!isLoadingImages && images.length > 0 && imagesViewMode === 'grid'">
            <div class="image-card" *ngFor="let image of images" (click)="openImagePreview(image)">
              <div class="image-card-thumb">
                <img *ngIf="getImageSrc(image)" [src]="getImageSrc(image)"
                     [alt]="image.imageFileName || 'Immagine'" loading="lazy">
                <div class="image-card-placeholder" *ngIf="!getImageSrc(image)">
                  <i class="fas" [ngClass]="isPdf(image) ? 'fa-file-pdf' : 'fa-image'"></i>
                </div>
                <span class="image-type-badge">{{ getImageTypeLabel(image) }}</span>
              </div>
              <div class="image-card-info">
                <span class="image-card-name" [title]="image.imageFileName">{{ image.imageFileName || '-' }}</span>
                <span class="image-card-date" *ngIf="image.imageCreatedAt">
                  {{ image.imageCreatedAt | date:'dd/MM/yy HH:mm' }}
                </span>
              </div>
            </div>
          </div>

          <!-- Vista lista (una sotto l'altra) -->
          <div class="images-list" *ngIf="!isLoadingImages && images.length > 0 && imagesViewMode === 'list'">
            <div class="image-list-item" *ngFor="let image of images">
              <div class="image-list-preview" (click)="openImagePreview(image)"
                   [title]="isPdf(image) ? 'Apri il documento' : 'Apri l\'anteprima'">
                <img *ngIf="getImageSrc(image)" [src]="getImageSrc(image)"
                     [alt]="image.imageFileName || 'Immagine'" loading="lazy">
                <div class="image-card-placeholder" *ngIf="!getImageSrc(image)">
                  <i class="fas" [ngClass]="isPdf(image) ? 'fa-file-pdf' : 'fa-image'"></i>
                </div>
              </div>
              <div class="image-list-info">
                <div class="event-header">
                  <span class="event-title">{{ image.imageFileName || getImageTypeLabel(image) }}</span>
                  <span class="event-date" *ngIf="image.imageCreatedAt">
                    <i class="far fa-clock me-1"></i>
                    {{ image.imageCreatedAt | date:'dd/MM/yyyy HH:mm' }}
                  </span>
                </div>
                <div class="event-meta">
                  <span class="event-type-badge">{{ getImageTypeLabel(image) }}</span>
                  <span class="event-meta-item" *ngIf="image.imageSource">
                    <i class="fas fa-server"></i> {{ image.imageSource }}
                  </span>
                  <span class="event-meta-item" *ngIf="image.imageSizeBytes">
                    <i class="fas fa-weight-hanging"></i> {{ formatImageSize(image.imageSizeBytes) }}
                  </span>
                  <span class="event-meta-item" *ngIf="image.imageCreatedBy">
                    <i class="fas fa-user"></i> {{ image.imageCreatedBy }}
                  </span>
                </div>
                <div class="event-note" *ngIf="image.imageDescription">
                  <i class="fas fa-sticky-note me-1"></i>{{ image.imageDescription }}
                </div>
                <div class="image-list-actions">
                  <button type="button" class="image-action-btn"
                          (click)="downloadImage(image)"
                          title="Scarica il file">
                    <i class="fas fa-download text-primary"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Anteprima immagine -->
          <div class="image-preview-overlay" *ngIf="previewImage" (click)="closeImagePreview()">
            <div class="image-preview-content" (click)="$event.stopPropagation()">
              <div class="image-preview-header">
                <span class="image-preview-title">{{ previewImage.imageFileName || getImageTypeLabel(previewImage) }}</span>
                <div class="image-preview-actions">
                  <button type="button" class="image-action-btn"
                          (click)="downloadImage(previewImage)"
                          title="Scarica il file">
                    <i class="fas fa-download text-primary"></i>
                  </button>
                  <button type="button" class="image-action-btn"
                          (click)="closeImagePreview()"
                          title="Chiudi anteprima">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="image-preview-body">
                <img [src]="getImageSrc(previewImage)" [alt]="previewImage.imageFileName || 'Immagine'">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab: Barcode/QR -->
      <div class="tab-content" *ngIf="activeTab === 'barcode'">
        <div class="parcel-details">

          <!-- Header riepilogo + toggle Barcode/QR -->
          <div class="routing-toolbar">
            <div class="routing-summary">
              <div class="routing-summary-item">
                <i class="fas" [ngClass]="codeType === 'barcode' ? 'fa-barcode' : 'fa-qrcode'"></i>
                <span>Codice da scansionare: <strong>{{ barcodeValue }}</strong></span>
              </div>
            </div>
            <div class="routing-view-toggle" role="group" aria-label="Tipo di codice">
              <button type="button"
                      class="view-toggle-btn"
                      [class.active]="codeType === 'barcode'"
                      (click)="setCodeType('barcode')"
                      title="Barcode lineare">
                <i class="fas fa-barcode"></i>
                <span>Barcode</span>
              </button>
              <button type="button"
                      class="view-toggle-btn"
                      [class.active]="codeType === 'qrcode'"
                      (click)="setCodeType('qrcode')"
                      title="QR Code">
                <i class="fas fa-qrcode"></i>
                <span>QR Code</span>
              </button>
            </div>
          </div>

          <!-- Card con il codice generato -->
          <div class="details-card">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas" [ngClass]="codeType === 'barcode' ? 'fa-barcode' : 'fa-qrcode'"></i>
              </div>
              <h5 class="details-card-title">
                {{ codeType === 'barcode' ? 'Barcode' : 'QR Code' }}
              </h5>
            </div>
            <div class="details-card-body">
              <div class="barcode-canvas-wrap">
                <canvas #barcodeCanvas *ngIf="codeType === 'barcode'"></canvas>
                <canvas #qrcodeCanvas *ngIf="codeType === 'qrcode'"></canvas>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Tab: Mappa -->
      <div class="tab-content" *ngIf="activeTab === 'map'">
        <div class="parcel-details">

          <!-- Stato: coordinate mancanti -->
          <ng-container *ngIf="!hasValidCoordinates()">
            <div class="details-card">
              <div class="details-card-header">
                <div class="details-card-icon" style="background: linear-gradient(135deg, #6c757d, #5c636a); box-shadow: 0 2px 6px rgba(108, 117, 125, 0.25);">
                  <i class="fas fa-map-marked-alt"></i>
                </div>
                <h5 class="details-card-title">Posizione Geografica</h5>
              </div>
              <div class="details-card-body">
                <div class="routing-state-box">
                  <i class="fas fa-map-marker-slash fa-3x text-muted mb-3"></i>
                  <p class="mb-1 fw-semibold">Coordinate mancanti</p>
                  <p class="text-muted mb-0 small">
                    Non sono disponibili le coordinate geografiche del destinatario per visualizzare la mappa.
                  </p>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Mappa + alert quando le coordinate ci sono -->
          <ng-container *ngIf="hasValidCoordinates()">
            <!-- Card con la mappa -->
            <div class="details-card"
                 [class.is-delivered]="isDelivered() && hasDeliveryCoordinates() && isDeliveryWithinRadius()">
              <div class="details-card-header">
                <div class="details-card-icon">
                  <i class="fas fa-map-marked-alt"></i>
                </div>
                <h5 class="details-card-title">
                  Posizione Geografica
                </h5>
                <div class="d-flex align-items-center flex-wrap gap-2 ms-auto">
                  <!-- Consegnato entro il raggio -->
                  <ng-container *ngIf="isDelivered() && hasDeliveryCoordinates() && isDeliveryWithinRadius()">
                    <span class="details-status-badge status-executed"
                          title="Il collo è stato consegnato correttamente entro il raggio di {{ client?.clientMaximumRange }}m dalla destinazione.">
                      <i class="fas fa-check-circle me-1"></i>Consegna Confermata
                    </span>
                    <span class="details-status-badge status-executed">
                      <i class="fas fa-circle status-dot"></i>
                      {{ (getDistanceFromDestination() || 0).toFixed(0) }}m dalla destinazione
                    </span>
                  </ng-container>
                  <!-- Consegnato fuori raggio -->
                  <ng-container *ngIf="isDelivered() && hasDeliveryCoordinates() && !isDeliveryWithinRadius()">
                    <span class="details-status-badge status-pending"
                          title="Il collo è stato consegnato ma la posizione è fuori dal raggio di {{ client?.clientMaximumRange }}m dalla destinazione.">
                      <i class="fas fa-exclamation-triangle me-1"></i>Consegnato fuori raggio
                    </span>
                    <span class="details-status-badge status-pending">
                      <i class="fas fa-circle status-dot"></i>
                      {{ (getDistanceFromDestination() || 0).toFixed(0) }}m dalla destinazione
                    </span>
                  </ng-container>
                  <!-- Non consegnato -->
                  <ng-container *ngIf="!isDelivered()">
                    <span class="details-status-badge"
                          [ngClass]="hasDeliveryCoordinates() && !isDeliveryWithinRadius() ? 'status-failed' : 'status-pending'"
                          [title]="!hasDeliveryCoordinates()
                            ? 'Il collo non è ancora stato consegnato.'
                            : (isDeliveryWithinRadius()
                              ? 'Il collo non è ancora stato consegnato, ma la posizione attuale è nel raggio di ' + client?.clientMaximumRange + 'm.'
                              : 'Il collo non è ancora stato consegnato e la posizione attuale è fuori dal raggio di ' + client?.clientMaximumRange + 'm dalla destinazione.')">
                      <i class="fas me-1"
                         [ngClass]="hasDeliveryCoordinates() && !isDeliveryWithinRadius() ? 'fa-times-circle' : 'fa-exclamation-triangle'"></i>In attesa di consegna
                    </span>
                    <span class="details-status-badge"
                          *ngIf="hasDeliveryCoordinates()"
                          [ngClass]="isDeliveryWithinRadius() ? 'status-in-progress' : 'status-failed'">
                      <i class="fas fa-circle status-dot"></i>
                      {{ (getDistanceFromDestination() || 0).toFixed(0) }}m dalla destinazione
                    </span>
                  </ng-container>
                </div>
              </div>
              <div class="details-card-body p-0">
                <div class="map-container" #mapContainer></div>
              </div>
            </div>
          </ng-container>

        </div>
      </div>

      <!-- Tab: Instradamento -->
      <div class="tab-content" *ngIf="activeTab === 'routing'">
        <div class="routing-section">
          <!-- Loading state -->
          <div class="routing-state-box" *ngIf="loadingComParcels">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Caricamento...</span>
            </div>
            <p class="mt-3 text-muted mb-0">Caricamento dati di instradamento...</p>
          </div>

          <!-- Empty state -->
          <div class="routing-state-box" *ngIf="!loadingComParcels && comParcels.length === 0">
            <i class="fas fa-route fa-3x text-muted mb-3"></i>
            <p class="text-muted mb-0">Nessun dato di instradamento disponibile per questo collo.</p>
          </div>

          <!-- Header riepilogo + toggle vista -->
          <div class="routing-toolbar" *ngIf="!loadingComParcels && comParcels.length > 0">
            <div class="routing-summary">
              <div class="routing-summary-item">
                <i class="fas fa-layer-group"></i>
                <span><strong>{{ comParcels.length }}</strong> {{ comParcels.length === 1 ? 'tappa' : 'tappe' }}</span>
              </div>
              <div class="routing-summary-item" *ngIf="dealer">
                <i class="fas fa-flag-checkered"></i>
                <span>Destinazione finale: <strong>{{ dealer?.dealerName || dealer?.dealerLegalName || '-' }}</strong></span>
              </div>
            </div>

            <div class="routing-view-toggle" role="group" aria-label="Modalità di visualizzazione">
              <button type="button"
                      class="view-toggle-btn"
                      [class.active]="routingViewMode === 'chain'"
                      (click)="setRoutingViewMode('chain')"
                      title="Vista percorso: punti di transito e aziende trasportatrici">
                <i class="fas fa-timeline"></i>
                <span>Percorso</span>
              </button>
              <button type="button"
                      class="view-toggle-btn"
                      [class.active]="routingViewMode === 'map'"
                      (click)="setRoutingViewMode('map')"
                      title="Vista mappa dei punti di transito">
                <i class="fas fa-map-marked-alt"></i>
                <span>Mappa</span>
              </button>
            </div>
          </div>

          <!-- Percorso view: O----T----O----T----O, punti di transito (O) collegati dalle tratte,
               ognuna con la sua azienda trasportatrice (T) -->
          <!-- Eventi di danno che non ricadono su un punto del percorso -->
          <div class="routing-chain-damage-note"
               *ngIf="!loadingComParcels && comParcels.length > 0 && routingViewMode === 'chain' && routingChainUnplacedDamages.length > 0">
            <i class="fas fa-exclamation-triangle"></i>
            <div>
              <strong>
                {{ getUnplacedDamageCount() === 1
                   ? 'Evento di danno non collocabile sul percorso'
                   : getUnplacedDamageCount() + ' eventi di danno non collocabili sul percorso' }}
              </strong>
              <span class="routing-chain-damage-note-item" *ngFor="let damage of routingChainUnplacedDamages">
                {{ damage.date ? (damage.date | date:'dd/MM/yyyy HH:mm') : 'Data non disponibile' }}
                <ng-container *ngIf="damage.endDate"> {{ getDamageRangeLabel(damage) }}</ng-container>
                <ng-container *ngIf="damage.count > 1"> ({{ damage.count }} eventi)</ng-container>
                <ng-container *ngIf="damage.place"> · {{ damage.place }} (fuori percorso)</ng-container>
                <ng-container *ngIf="!damage.place"> · magazzino non indicato</ng-container>
              </span>
            </div>
          </div>

          <!-- Collo segnalato come danneggiato, ma senza evento di danno: non c'è nessun punto
               del percorso a cui collegarlo -->
          <div class="routing-chain-damage-note"
               *ngIf="!loadingComParcels && comParcels.length > 0 && routingViewMode === 'chain' && isDamagedWithoutEvent()">
            <i class="fas fa-exclamation-triangle"></i>
            <div>
              <strong>Collo danneggiato: evento di danno non trovato</strong>
              <span class="routing-chain-damage-note-item">
                Il collo è segnalato come danneggiato, ma non risulta nessun evento di danno da collocare sul percorso.
              </span>
            </div>
          </div>

          <div class="routing-chain"
               *ngIf="!loadingComParcels && comParcels.length > 0 && routingViewMode === 'chain'">
            <!-- Griglia: punto, tratta, punto, ... sull'ultima riga; sopra, una riga per ogni corsia di deviazione -->
            <div class="routing-chain-track" [style.grid-template-columns]="routingChainGridColumns">

              <!-- Deviazioni (tappe MISROUTING): corsia parallela al percorso, raccordata ai punti
                   da cui parte e in cui rientra; i punti fuori percorso hanno il nome sopra -->
              <div class="chain-detour" *ngFor="let detour of routingChainDetours"
                   [class.is-backward]="detour.backward"
                   [style.grid-column]="detour.gridColumn"
                   [style.grid-row]="routingChainDetourLanes - detour.lane"
                   [style.--detour-lane]="detour.lane"
                   [style.--detour-lane-height]="routingChainDetourLaneHeight + 'px'">
                <span class="chain-detour-link chain-detour-link--left" *ngIf="detour.leftAnchored"></span>
                <span class="chain-detour-link chain-detour-link--right" *ngIf="detour.rightAnchored"></span>
                <div class="chain-detour-track">
                  <div class="chain-detour-point chain-detour-point--edge" *ngIf="!detour.startAnchored">
                    <ng-container *ngTemplateOutlet="detourPointTpl; context: { name: detour.startName, place: detour.startPlace, damages: detour.startDamages, pickings: detour.startPickings }"></ng-container>
                  </div>
                  <ng-container *ngFor="let leg of detour.legs; let isLastLeg = last">
                    <div class="chain-detour-leg">
                      <span class="chain-detour-chip" [title]="leg.title">
                        <i class="fas" [ngClass]="detour.backward ? 'fa-arrow-left' : 'fa-shuffle'"></i>
                        <span class="chain-detour-chip-text">
                          Misrouting<ng-container *ngIf="leg.carrierName"> · {{ leg.carrierName }}</ng-container>
                        </span>
                      </span>
                      <!-- Danni nel magazzino di arrivo della tappa: linea tratteggiata dal suo vettore
                           fino all'etichetta di danno sotto il punto -->
                      <span class="chain-detour-damage-link" *ngIf="leg.damages.length > 0" aria-hidden="true"></span>
                    </div>
                    <div class="chain-detour-point" *ngIf="!isLastLeg">
                      <ng-container *ngTemplateOutlet="detourPointTpl; context: { name: leg.to, place: leg.toPlace, damages: leg.damages, pickings: leg.pickings }"></ng-container>
                    </div>
                  </ng-container>
                  <div class="chain-detour-point chain-detour-point--edge" *ngIf="!detour.endAnchored">
                    <ng-container *ngTemplateOutlet="detourPointTpl; context: { name: detour.endName, place: detour.endPlace, damages: detour.legs[detour.legs.length - 1].damages, pickings: detour.legs[detour.legs.length - 1].pickings }"></ng-container>
                  </div>
                </div>
              </div>

              <!-- Punto di transito fuori percorso (sempre un magazzino): stesso disegno dei punti del
                   percorso, in rosso, con ruolo, nome e località sopra il pallino e i danni sotto -->
              <ng-template #detourPointTpl let-name="name" let-place="place" let-damages="damages" let-pickings="pickings">
                <div class="step-marker-dot status-failed">
                  <i class="fas fa-warehouse"></i>
                  <span class="chain-point-damage-badge" *ngIf="damages?.length" aria-hidden="true">
                    <i class="fas fa-exclamation"></i>
                  </span>
                  <span class="chain-point-picking-badges" *ngIf="pickings?.length">
                    <span class="chain-point-picking-badge" *ngFor="let picking of pickings"
                          [title]="getPickingTitle(picking)">
                      <i class="fas fa-mobile-alt"></i>
                      <span *ngIf="picking.date">{{ picking.date | date:'dd/MM/yyyy HH:mm' }}</span>
                      <span *ngIf="picking.count > 1">×{{ picking.count }}</span>
                    </span>
                  </span>
                </div>
                <div class="chain-detour-point-label">
                  <span class="chain-detour-point-role">Transito</span>
                  <span class="chain-detour-point-name" [title]="name">{{ name }}</span>
                  <span class="chain-detour-point-place" *ngIf="place">{{ place }}</span>
                </div>
                <div class="chain-detour-damages" *ngIf="damages?.length">
                  <ng-container *ngFor="let damage of damages">
                    <ng-container *ngTemplateOutlet="damageChipTpl; context: { damage: damage }"></ng-container>
                  </ng-container>
                </div>
              </ng-template>

              <!-- Etichetta di un gruppo di eventi di danno (stesso magazzino, entro 6 ore) -->
              <ng-template #damageChipTpl let-damage="damage">
                <span class="chain-point-damage" [title]="getDamageTitle(damage)">
                  <span class="chain-point-damage-label">
                    <i class="fas fa-exclamation-triangle"></i> Danno<ng-container *ngIf="damage.count > 1"> ×{{ damage.count }}</ng-container>
                  </span>
                  <span class="chain-point-damage-date" *ngIf="damage.date">{{ damage.date | date:'dd/MM/yyyy HH:mm' }}</span>
                  <span class="chain-point-damage-date" *ngIf="damage.endDate">{{ getDamageRangeLabel(damage) }}</span>
                </span>
              </ng-template>

              <ng-container *ngFor="let node of routingChain; let i = index; let isFirst = first; let isLast = last">

                <!-- O: punto di transito -->
                <div class="chain-point" [class.is-final]="isLast"
                     [style.grid-column]="2 * i + 1"
                     [style.grid-row]="routingChainDetourLanes + 1">
                  <div class="step-marker-dot"
                       [ngClass]="isLast && parcel?.parcelDeliveryDate ? 'status-completed' : getRoutingStatusClass(node.point.status)">
                    <i class="fas" [ngClass]="node.point.kind === 'dealer' ? 'fa-store' : 'fa-warehouse'"></i>
                    <span class="chain-point-damage-badge" *ngIf="node.damages.length > 0" aria-hidden="true">
                      <i class="fas fa-exclamation"></i>
                    </span>
                    <!-- Pickerate col palmare nel magazzino: data della prima, ×N se più di una entro 6 ore -->
                    <span class="chain-point-picking-badges" *ngIf="node.pickings.length > 0">
                      <span class="chain-point-picking-badge" *ngFor="let picking of node.pickings"
                            [title]="getPickingTitle(picking)">
                        <i class="fas fa-mobile-alt"></i>
                        <span *ngIf="picking.date">{{ picking.date | date:'dd/MM/yyyy HH:mm' }}</span>
                        <span *ngIf="picking.count > 1">×{{ picking.count }}</span>
                      </span>
                    </span>
                  </div>
                  <span class="chain-point-role">
                    {{ isLast ? (parcel?.parcelDeliveryDate ? 'Consegnato' : 'Destinazione') : (isFirst ? 'Partenza' : 'Transito') }}
                  </span>
                  <span class="chain-point-name" [title]="node.point.name">{{ node.point.name }}</span>
                  <span class="chain-point-place" *ngIf="node.point.place">{{ node.point.place }}</span>
                </div>

                <!-- Eventi di danno registrati in questo punto: riga sotto il percorso. Dal vettore della
                     tratta che arriva sul punto scende una linea tratteggiata che corre lungo la tratta
                     fino all'evento di danno -->
                <div class="chain-damage-row" *ngIf="node.damages.length > 0"
                     [class.is-first]="i === 0"
                     [style.grid-column]="i === 0 ? 1 : (2 * i) + ' / ' + (2 * i + 2)"
                     [style.grid-row]="routingChainDetourLanes + 2">
                  <span class="chain-damage-link" *ngIf="i > 0"
                        [class.is-linked]="!!routingChain[i - 1].leg"
                        aria-hidden="true"></span>
                  <div class="chain-damage-chips">
                    <ng-container *ngFor="let damage of node.damages">
                      <ng-container *ngTemplateOutlet="damageChipTpl; context: { damage: damage }"></ng-container>
                    </ng-container>
                  </div>
                </div>

                <!-- T: tratta verso il punto successivo, con l'azienda trasportatrice -->
                <div class="chain-leg" *ngIf="!isLast" [ngClass]="getRoutingStatusClass(node.leg?.status)"
                     [style.grid-column]="2 * i + 2"
                     [style.grid-row]="routingChainDetourLanes + 1">
                  <div class="chain-leg-line"></div>
                  <ng-container *ngIf="node.leg as leg">
                    <div class="chain-leg-carrier"
                         [class.is-unassigned]="!leg.carrierCode"
                         [title]="leg.carrierCode ? leg.carrierName + ' (' + leg.carrierCode + ')' : 'Vettore non assegnato'">
                      <i class="fas fa-truck"></i>
                      <span class="chain-leg-carrier-name">{{ leg.carrierName || 'Non assegnato' }}</span>
                    </div>
                    <span class="chain-leg-seq" [title]="'Tappa ' + leg.sequence">Trasporto {{ leg.transport }}</span>
                    <span class="mini-status" [ngClass]="getRoutingStatusClass(leg.status)">
                      <i class="fas fa-circle"></i>
                      {{ getRoutingStatusLabel(leg.status) }}
                    </span>
                  </ng-container>
                </div>

              </ng-container>
            </div>
          </div>

          <!-- Tabella degli orari, sotto il percorso: inizio e fine di ogni tappa (soste comprese) -->
          <div class="routing-schedule"
               *ngIf="!loadingComParcels && comParcels.length > 0 && routingViewMode === 'chain'">
            <div class="routing-schedule-title">
              <i class="fas fa-clock"></i>
              <span>Orari delle tappe</span>
            </div>
            <div class="routing-schedule-scroll">
              <table class="routing-schedule-table">
                <thead>
                  <tr>
                    <th>Tappa</th>
                    <th>Da</th>
                    <th>A</th>
                    <th>Vettore</th>
                    <th>Inizio</th>
                    <th>Fine</th>
                    <th>Stato</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of routingSchedule">
                    <td>
                      <span class="mini-seq" *ngIf="row.sequence">{{ row.sequence }}</span>
                      <span class="schedule-misrouting-tag" *ngIf="row.misrouting">
                        <i class="fas fa-shuffle"></i> Misrouting
                      </span>
                    </td>
                    <td>
                      {{ row.from }}
                      <ng-container *ngTemplateOutlet="scheduleDamagesTpl; context: { damages: row.damages }"></ng-container>
                    </td>
                    <td>{{ row.to }}</td>
                    <td>
                      <ng-container *ngIf="row.carrierName; else noScheduleValue">{{ row.carrierName }}</ng-container>
                    </td>
                    <td class="schedule-time">
                      <ng-container *ngIf="row.start; else noScheduleValue">{{ row.start | date:'dd/MM/yyyy HH:mm' }}</ng-container>
                    </td>
                    <td class="schedule-time">
                      <ng-container *ngIf="row.end; else noScheduleValue">{{ row.end | date:'dd/MM/yyyy HH:mm' }}</ng-container>
                    </td>
                    <td>
                      <span class="mini-status" [ngClass]="getRoutingStatusClass(row.status)">
                        <i class="fas fa-circle"></i>
                        {{ getRoutingStatusLabel(row.status) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-template #noScheduleValue><span class="schedule-empty">-</span></ng-template>
            <!-- Danni registrati nel magazzino, a capo sotto il suo nome -->
            <ng-template #scheduleDamagesTpl let-damages="damages">
              <span class="schedule-damage" *ngFor="let damage of damages" [title]="getDamageTitle(damage)">
                <i class="fas fa-exclamation-triangle"></i>
                Danno<ng-container *ngIf="damage.count > 1"> ×{{ damage.count }}</ng-container>
                <ng-container *ngIf="damage.date"> · {{ damage.date | date:'dd/MM/yyyy HH:mm' }}</ng-container>
                <ng-container *ngIf="damage.endDate"> {{ getDamageRangeLabel(damage) }}</ng-container>
              </span>
            </ng-template>
          </div>

          <!-- Map view: punti di transito e tratte su mappa Leaflet -->
          <div class="routing-map-view"
               *ngIf="!loadingComParcels && comParcels.length > 0 && routingViewMode === 'map'">

            <!-- Nessun punto georeferenziato -->
            <div class="routing-state-box" *ngIf="routingMapPoints.length === 0">
              <i class="fas fa-map-marked-alt fa-3x text-muted mb-3"></i>
              <p class="text-muted mb-1">Nessun punto di transito georeferenziato per questo collo.</p>
              <p class="text-muted small mb-0">
                Le coordinate dei magazzini e del dealer di destinazione non sono disponibili.
              </p>
            </div>

            <ng-container *ngIf="routingMapPoints.length > 0">
              <!-- Barra strumenti mappa -->
              <div class="routing-map-toolbar">
                <div class="routing-map-legend">
                  <span class="routing-legend-item">
                    <span class="legend-dot legend-dot-warehouse"><i class="fas fa-warehouse"></i></span>
                    Magazzino
                  </span>
                  <span class="routing-legend-item">
                    <span class="legend-dot legend-dot-dealer"><i class="fas fa-store"></i></span>
                    Dealer
                  </span>
                  <span class="routing-legend-item">
                    <span class="legend-line legend-line-done"></span>
                    Tappa eseguita
                  </span>
                  <span class="routing-legend-item">
                    <span class="legend-line legend-line-pending"></span>
                    Tappa da eseguire
                  </span>
                </div>

                <div class="routing-map-actions">
                  <!-- Selettore stile mappa -->
                  <div class="routing-map-style-switch" role="group" aria-label="Stile della mappa">
                    <button type="button"
                            class="map-style-btn"
                            *ngFor="let style of routingMapStyles"
                            [class.active]="routingMapStyleId === style.id"
                            (click)="setRoutingMapStyle(style.id)"
                            [title]="'Mappa ' + style.label">
                      <i class="fas" [ngClass]="style.icon"></i>
                      <span>{{ style.label }}</span>
                    </button>
                  </div>

                  <!-- Etichette: punti di transito e tratte, attivabili separatamente -->
                  <div class="routing-map-labels-switch" role="group" aria-label="Etichette della mappa">
                    <button type="button"
                            class="map-label-btn"
                            [class.active]="routingMapPointLabelsVisible"
                            (click)="toggleRoutingMapPointLabels()"
                            [attr.aria-pressed]="routingMapPointLabelsVisible"
                            title="Mostra/nascondi le etichette dei punti di transito">
                      <i class="fas fa-map-pin"></i>
                      <span>Punti</span>
                    </button>
                    <button type="button"
                            class="map-label-btn"
                            [class.active]="routingMapLegLabelsVisible"
                            (click)="toggleRoutingMapLegLabels()"
                            [attr.aria-pressed]="routingMapLegLabelsVisible"
                            title="Mostra/nascondi le etichette delle tratte">
                      <i class="fas fa-route"></i>
                      <span>Tratte</span>
                    </button>
                  </div>
                  <button type="button"
                          class="view-toggle-btn map-action-btn"
                          (click)="fitRoutingMap()"
                          title="Inquadra tutti i punti dell'instradamento">
                    <i class="fas fa-expand"></i>
                    <span>Centra</span>
                  </button>
                </div>
              </div>

              <!-- Mappa Leaflet -->
              <div class="routing-map-container" #routingMapContainer></div>

              <!-- Riepilogo sotto la mappa -->
              <div class="routing-map-footer">
                <span class="routing-map-footer-item">
                  <i class="fas fa-map-pin"></i>
                  <strong>{{ routingMapPoints.length }}</strong>
                  {{ routingMapPoints.length === 1 ? 'punto' : 'punti' }} di transito
                </span>
                <span class="routing-map-footer-item">
                  <i class="fas fa-route"></i>
                  <strong>{{ routingMapLegs.length }}</strong>
                  {{ routingMapLegs.length === 1 ? 'tratta' : 'tratte' }}
                </span>
                <span class="routing-map-footer-item hint">
                  <i class="fas fa-info-circle"></i>
                  Clicca su una linea per il dettaglio della tratta · distanze in linea d'aria
                </span>
                <span class="routing-map-footer-item warning" *ngIf="routingMapMissingLegs > 0">
                  <i class="fas fa-exclamation-triangle"></i>
                  {{ routingMapMissingLegs }}
                  {{ routingMapMissingLegs === 1 ? 'tappa non mostrata' : 'tappe non mostrate' }}
                  (coordinate mancanti)
                </span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Tab: Funzionalità -->
      <div class="tab-content" *ngIf="activeTab === 'functions'">
        <div class="parcel-details">

          <div class="routing-toolbar">
            <div class="routing-summary">
              <div class="routing-summary-item">
                <i class="fas fa-cogs"></i>
                <span>Azioni disponibili sul collo</span>
              </div>
            </div>
          </div>

          <div class="details-card">
            <div class="details-card-body">
              <div class="functions-grid">

                <!-- Invalida / Rivalida per Borderò -->
                <div class="function-card"
                     [ngClass]="parcel?.parcelInactiveForLoadingLists ? 'variant-success' : 'variant-danger'"
                     (click)="openLoadingListsPopupForCurrentParcel()">
                  <div class="function-card-icon">
                    <i class="fas" [ngClass]="parcel?.parcelInactiveForLoadingLists ? 'fa-undo' : 'fa-ban'"></i>
                  </div>
                  <div class="function-card-text">
                    <h6 class="function-card-title">
                      {{ parcel?.parcelInactiveForLoadingLists ? 'Rivalida nei Borderò' : 'Invalida nei Borderò' }}
                    </h6>
                    <p class="function-card-desc">
                      {{ parcel?.parcelInactiveForLoadingLists
                          ? 'Ridichiara valido il collo per includerlo nella lista dei colli nei borderò'
                          : 'Dichiara invalido il collo per escluderlo dalla lista dei colli nei borderò' }}
                    </p>
                  </div>
                  <div class="function-card-action">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>

                <!-- Stampa Etichetta Singola -->
                <div class="function-card variant-primary" (click)="printLabel()">
                  <div class="function-card-icon">
                    <i class="fas fa-tag"></i>
                  </div>
                  <div class="function-card-text">
                    <h6 class="function-card-title">Stampa Etichetta Collo</h6>
                    <p class="function-card-desc">Genera e scarica l'etichetta per questo collo</p>
                  </div>
                  <div class="function-card-action">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>

                <!-- Stampa Tutte le Etichette della Bolla -->
                <div class="function-card variant-primary"
                     (click)="printAllLabels()"
                     *ngIf="allParcels && allParcels.length > 1">
                  <div class="function-card-icon">
                    <i class="fas fa-tags"></i>
                  </div>
                  <div class="function-card-text">
                    <h6 class="function-card-title">Stampa Tutte le Etichette</h6>
                    <p class="function-card-desc">
                      Genera e scarica tutte le etichette della bolla ({{ allParcels.length }} colli)
                    </p>
                  </div>
                  <div class="function-card-action">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>

                <!-- Stampa Documento Bolla -->
                <div class="function-card variant-primary"
                     (click)="printWaybill()"
                     *ngIf="waybill">
                  <div class="function-card-icon">
                    <i class="fas fa-file-pdf"></i>
                  </div>
                  <div class="function-card-text">
                    <h6 class="function-card-title">Stampa Documento Bolla</h6>
                    <p class="function-card-desc">Genera e scarica il documento PDF completo della bolla</p>
                  </div>
                  <div class="function-card-action">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>

                <!-- Invia in Axylog -->
                <div class="function-card variant-info" (click)="sendToAxylog()">
                  <div class="function-card-icon">
                    <i class="fas fa-paper-plane"></i>
                  </div>
                  <div class="function-card-text">
                    <h6 class="function-card-title">Invia in Axylog</h6>
                    <p class="function-card-desc">Sincronizza i dati del collo con il sistema Axylog</p>
                  </div>
                  <div class="function-card-action">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>

                <!-- Invia via Mail -->
                <div class="function-card variant-info" (click)="sendByEmail()">
                  <div class="function-card-icon">
                    <i class="fas fa-envelope"></i>
                  </div>
                  <div class="function-card-text">
                    <h6 class="function-card-title">Invia via Mail</h6>
                    <p class="function-card-desc">Invia i dettagli e la documentazione del collo via email</p>
                  </div>
                  <div class="function-card-action">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-secondary" (click)="close()">
          <i class="fas fa-times me-2"></i>
          Chiudi
        </button>
      </div>
    </div>
  </div>
</div>
